import { useNavigate } from 'react-router-dom';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Back Button */}
          <div className="mb-8">
            <button 
              onClick={() => navigate('/')}
              className="inline-flex items-center hover:opacity-80 transition-colors cursor-pointer group"
              style={{ color: '#B80E10' }}
            >
              <i className="ri-arrow-left-line text-xl mr-2 group-hover:-translate-x-1 transition-transform"></i>
              <span className="font-medium">Zurück zur Hauptseite</span>
            </button>
          </div>

          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Impressum</h1>
            <div className="w-24 h-1 mx-auto" style={{ backgroundColor: '#B80E10' }}></div>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <div className="space-y-8">
              
              {/* Section 1 */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>1</span>
                  Angaben gemäß § 5 TMG (Telemediengesetz)
                </h3>
                <div className="mt-6">
                  <p className="text-gray-800 leading-relaxed">
                    <strong>handgepackt eGbR</strong><br />
                    Römerstr. 1<br />
                    53424 Remagen<br />
                    Deutschland
                  </p>
                </div>
              </section>

              {/* Section 2 */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>2</span>
                  Vertreten durch die Gesellschafter
                </h3>
                <div className="space-y-4">
                  <div>
                    <ul className="text-gray-800 space-y-2">
                      <li><strong>Diana Runkel</strong></li>
                      <li><strong>Jan Aurel Rohde</strong></li>
                    </ul>
                  </div>
                </div>
              </section>

              {/* Section 3 */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>3</span>
                  Kontakt
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="text-gray-800 space-y-2">
                      <p><strong>Telefon:</strong> +49 2642 2913998</p>
                      <p><strong>Telefax:</strong> +49 2642 2913999</p>
                      <p><strong>E-Mail:</strong> hallo@handgepackt.de</p>
                      <p><strong>Website:</strong> www.handgepackt.de</p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 4 */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>4</span>
                  Gesellschaftsregister
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="text-gray-800 space-y-2">
                      <p><strong>Sitz der Gesellschaft:</strong> Remagen</p>
                      <p><strong>Registergericht:</strong> Koblenz</p>
                      <p><strong>Registernummer:</strong> GsR 847</p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 5 */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>5</span>
                  Steuernummern
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="text-gray-800 space-y-2">
                      <p><strong>Steuernummer:</strong> 01/059/32938</p>
                      <p><strong>Finanzamt:</strong> Bad Neuenahr-Ahrweiler</p>
                      <p><strong>USt-IdNr.:</strong> beantragt</p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 6 */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>6</span>
                  Verbraucherstreitbeilegung/OS-Plattform
                </h3>
                <div className="space-y-4">
                  <p className="text-gray-700 leading-relaxed">
                    Die Europäische Kommission stellt keine Plattform zur Online-Streitbeilegung (OS) mehr bereit.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Wir sind weder bereit noch verpflichtet, an einem Streitbeilegungsverfahren vor einer 
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </section>
            </div>

            {/* Contact Box */}
            <div className="mt-12 p-6 rounded-lg" style={{ backgroundColor: '#FEF2F2', borderColor: '#B80E10', borderWidth: '1px' }}>
              <div className="flex items-center mb-4">
                <i className="ri-information-line text-xl mr-3" style={{ color: '#B80E10' }}></i>
                <h4 className="text-lg font-semibold text-gray-900">Rechtliche Hinweise</h4>
              </div>
              <p className="text-gray-700">
                Bei rechtlichen Fragen oder Anliegen können Sie sich jederzeit an uns wenden:
              </p>
              <div className="mt-3">
                <p className="text-gray-800 font-medium">
                  E-Mail:{' '}
                  <a href="mailto:hallo@handgepackt.de" className="hover:opacity-80 underline" style={{ color: '#B80E10' }}>
                    hallo@handgepackt.de
                  </a>
                </p>
                <p className="text-gray-800">Adresse: handgepackt eGbR, Römerstr. 1, 53424 Remagen</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;